import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Topbar from '../../components/topbar/topbar';
import './contract_items.css';
import { Dropdown } from 'react-bootstrap';
import { FaFilter, FaEye, FaHamburger } from 'react-icons/fa';
import { useFetch } from '../../components/hooks/useFetch';
import Loading from '../../components/loader/loading';
import { RxHamburgerMenu } from "react-icons/rx";

const ContractItemsPage = () => {
  const [page, setPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const perPage = 10;

  // 🔹 Filtros digitados (temporários)
  const [filters, setFilters] = useState({
    equipamento: '',
    categoria: '',
    serial: '',
    apelido: '',
    sala: '',
    setor: '',
    cliente: '',
    contrato: '',
    unidade: '',
    cidade: '',
    extra1: '',
    extra2: ''
  });

  // 🔹 Filtros aplicados (usados na API)
  const [appliedFilters, setAppliedFilters] = useState({});

  const handleFilterChange = (e, key) => {
    setFilters({ ...filters, [key]: e.target.value });
  };

  // 🔹 Montar query string com filtros aplicados
  const queryParams = new URLSearchParams({
    per_page: perPage,
    page,
    ...Object.fromEntries(
      Object.entries(appliedFilters).filter(([_, value]) => value)
    )
  }).toString();

  const response = useFetch(`admin/contract-items?${queryParams}`);
  const loading = !response?.data?.models?.data;
  const items = response?.data?.models?.data || [];
  const totalPages = response?.data?.models?.last_page || 1;

  const formatItem = (item) => ({
    id: item.id,
    equipamento: [
      {
        categoria: item.equipment_model?.equipment_category?.name || '-',
        nome: item.equipment_model?.name || '-',
        brand: item.equipment_model?.equipment_brand.name || '-',
        active: item.active
      }
    ],
    identificacao: [
      {
        serial: item.serial || '-',
        apelido: item.nickname || '-'
      }
    ],
    localizacao: [
      {
        sala: item.room?.name || '-',
        setor: item.room?.sector?.name || '-',
      }
    ],
    cliente: [
      {
        name: item.contract?.customer?.name || '-',
        contract: item.contract?.name || '-'
      }
    ],
    endereco: [
      {
        unidade: item.room?.sector?.unit?.name
          ? `⚡ ${item.room?.sector?.unit?.name}`
          : '-',
        cidade: item.room?.sector?.unit?.city?.name || '-'
      }
    ],
    action: FaEye,
    original: item
  });

  const paginatedItems = items.map(formatItem);
  
  return (
    <div className="wrapper d-flex align-items-stretch">
      <Sidebar />
      <div id="content">
        <Topbar />
        <div className="content_all">
          <div className="header">
            <p className="title">ATIVOS DOS CLIENTES</p>
            <div className="pagination">
              <button disabled={page === 1} onClick={() => setPage(page - 1)}>&lt;</button>
              <span className="page-info">Página {page} de {totalPages}</span>
              <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>&gt;</button>
            </div>
          </div>

          {loading ? (
            <Loading />
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr className="thead-row">
                    <th style={{ paddingLeft: 16 }}>Equipamento</th>
                    <th>Identificação</th>
                    <th>Localização</th>
                    <th>Cliente</th>
                    <th>Endereço</th>
                    <th>
                      <div
                        className='icon-filter'
                        style={{ cursor: 'pointer' }}
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        <FaFilter style={{ color: '#25520fca' }} />
                      </div>
                    </th>
                  </tr>

                  {showFilter && (
                    <tr className="filter-row">
                      <td colSpan={6} className='p-3'>
                        <div className="filter-content-grid">
                          <div className="filter-column">
                            <input className="filter-input" type="text" placeholder="Filtro Equipamento"
                              value={filters.equipamento}
                              onChange={(e) => handleFilterChange(e, 'equipamento')}
                            />
                            <input className="filter-input" type="text" placeholder="Filtro Categoria"
                              value={filters.categoria}
                              onChange={(e) => handleFilterChange(e, 'categoria')}
                            />
                          </div>
                          <div className="filter-column">
                            <input className="filter-input" type="text" placeholder="Filtro Serial"
                              value={filters.serial}
                              onChange={(e) => handleFilterChange(e, 'serial')}
                            />
                            <input className="filter-input" type="text" placeholder="Filtro Apelido"
                              value={filters.apelido}
                              onChange={(e) => handleFilterChange(e, 'apelido')}
                            />
                          </div>
                          <div className="filter-column">
                            <input className="filter-input" type="text" placeholder="Filtro Sala"
                              value={filters.sala}
                              onChange={(e) => handleFilterChange(e, 'sala')}
                            />
                            <input className="filter-input" type="text" placeholder="Filtro Setor"
                              value={filters.setor}
                              onChange={(e) => handleFilterChange(e, 'setor')}
                            />
                          </div>
                          <div className="filter-column">
                            <input className="filter-input" type="text" placeholder="Filtro Cliente"
                              value={filters.cliente}
                              onChange={(e) => handleFilterChange(e, 'cliente')}
                            />
                            <input className="filter-input" type="text" placeholder="Filtro Contrato"
                              value={filters.contrato}
                              onChange={(e) => handleFilterChange(e, 'contrato')}
                            />
                          </div>
                          <div className="filter-column">
                            <input className="filter-input" type="text" placeholder="Filtro Unidade"
                              value={filters.unidade}
                              onChange={(e) => handleFilterChange(e, 'unidade')}
                            />
                            <input className="filter-input" type="text" placeholder="Filtro Cidade"
                              value={filters.cidade}
                              onChange={(e) => handleFilterChange(e, 'cidade')}
                            />
                          </div>
                          <div className="filter-column">
                            <input className="filter-input" type="text" placeholder="Filtro Extra 1"
                              value={filters.extra1}
                              onChange={(e) => handleFilterChange(e, 'extra1')}
                            />
                            <input className="filter-input" type="text" placeholder="Filtro Extra 2"
                              value={filters.extra2}
                              onChange={(e) => handleFilterChange(e, 'extra2')}
                            />
                          </div>
                        </div>

                        <button
                          className="filter-button"
                          style={{ marginTop: 10, marginBottom: 10 }}
                          onClick={() => {
                            setAppliedFilters(filters);
                            setPage(1);
                          }}
                        >
                          Aplicar
                        </button>
                      </td>
                    </tr>
                  )}
                </thead>

                <tbody>
                  <tr style={{ height: 30 }} />
                  {paginatedItems.map((item, idx) => (
                    <tr key={idx}>
                      <td colSpan={6}>
                        <div className="tr-card">

                          <div className="td-col">
                            {item.equipamento.map((e, i) => (
                              <div key={i}>
                                <div>{e.categoria} - {e.brand} - {e.nome}</div>
                                <div>{e.active ? "Ativo" : "Desativado"}</div>
                              </div>
                            ))}
                          </div>

                          <div className="td-col">
                            {item.identificacao.map((e, i) => (
                              <div key={i}>
                                <div>{e.serial}</div>
                                <div>{e.apelido}</div>
                              </div>
                            ))}
                          </div>

                          <div className="td-col">
                            {item.localizacao.map((e, i) => (
                              <div key={i}>
                                <div>{e.sala}</div>
                                <div>{e.setor}</div>
                              </div>
                            ))}
                          </div>

                          <div className="td-col">
                            {item.cliente.map((e, i) => (
                              <div key={i}>
                                <div>{e.name}</div>
                                <div>{e.contract}</div>
                              </div>
                            ))}
                          </div>

                          <div className="td-col">
                            {item.endereco.map((e, i) => (
                              <div key={i}>
                                <div>{e.unidade}</div>
                                <div>{e.cidade}</div>
                              </div>
                            ))}
                          </div>

                          {/* 🔥 Aqui está o dropdown substituindo o modal */}
                          <div className="td-col action-col">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant='none'
                                id={`dropdown-${idx}`}
                                size="sm"
                              >
                                <RxHamburgerMenu size={16} />
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item
                                  style={{padding: 10}}
                                  onClick={() => {
                                    window.location.href = `/gestao/permisssao-equipamentos-item-contrato/${item.id}`;
                                  }}
                                >
                                  Permissão de usuários 
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>

                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default ContractItemsPage;
